import { useMemo } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useViewLocationsByGroupsWithoutPaginationFilterByLocationCode } from 'src/hooks';
import { IViewLocationList } from 'src/interfaces';

import {
  formatFormValues,
  getSelectedLocationWithViewLocationType,
} from './AssignLocationsModal.helper';
import { FormProps } from './AssignLocationsModal.interface';

export const useAssignLocationsModal = (locationCode: string) => {
  const {
    data: viewLocationGroupData,
    isLoading: isLoadingViewLocationGroups,
  } = useViewLocationsByGroupsWithoutPaginationFilterByLocationCode(
    null,
    { enabled: locationCode !== undefined, staleTime: 0 },
    [`locations.location_code=${locationCode}`],
  );

  const selectedLocation = useMemo(() => {
    if (!viewLocationGroupData || !locationCode) return undefined;

    return getSelectedLocationWithViewLocationType(
      viewLocationGroupData,
      locationCode,
    );
  }, [viewLocationGroupData, locationCode]);

  const locationGroups = (viewLocationGroupData?.locationGroups ?? []).filter(
    (locationGroup) => !locationGroup.is_default,
  );

  const formMethod = useForm<FormProps>({
    values: {
      channels: formatFormValues(
        selectedLocation ?? ({} as IViewLocationList),
        locationGroups,
      ),
    },
  });

  const fieldArray = useFieldArray({
    control: formMethod.control,
    name: 'channels',
    keyName: 'uid',
  });

  return {
    fieldArray,
    formMethod,
    selectedLocation,
    isLoadingViewLocationGroups,
  };
};
